module.exports = __webpack_public_path__ + "static/media/gold-bottle-cap.4f3eda4c.png";